import Vue from "vue";
import singleSpaVue from "single-spa-vue";

export function buildVueParcel(appOptions) {
	const vueLifecycles = singleSpaVue({Vue, appOptions});
	return {
		bootstrap: vueLifecycles.bootstrap,
		mount: vueLifecycles.mount,
		unmount: vueLifecycles.unmount
	};
}

export function buildVueLazyParcel(routerBuilder, vueApp) {
	return {
		generateParcel: () => {
			let routerData = routerBuilder();
			return buildVueParcel({
				render: h => h(vueApp),
				router: routerData.router
			});
		}
	};
}
